import { useEffect, useState } from 'react';
import Cookies from 'react-cookies';
import { useRouter } from 'next/router';
import { SearchOutlined } from '@ant-design/icons';
import {
	Affix,
	Avatar,
	Button,
	Col,
	Dropdown,
	Grid,
	Image,
	Input,
	Menu,
	Modal,
	Row,
	Typography,
} from 'antd';

import { ButtonBorder, ButtonBorderKomunitas } from 'src/components/Forms/Button';
import IconCustom from 'src/components/Icon/Custom';
import messageC from 'src/components/Message';
// import useInsiderTrackingPageUser from 'src/hooks/useInsiderTrackingUser';
import { decryptDLoginBE } from 'src/utils/func/encrypt';

import styles from './headerNavigator.module.less';
const HeaderNavigator = () => {
	const { xs } = Grid.useBreakpoint();
	const router = useRouter();
	const [count, setCount] = useState(0);
	const [nilai, setNilai] = useState(false);
	const handleClick = () => {
		setCount(count + 1);
		if (count % 2 === 0) {
			setNilai(true);
		} else {
			setNilai(false);
		}
	};
	const [dataLogin, setDataLogin] = useState<any>({});
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isModalOpenSession, setIsModalOpenSession] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			const userData = Cookies.load('d_login') ? decryptDLoginBE(Cookies.load('d_login')) : [];
			setDataLogin(userData);
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'userData.profile',
				uid: !userData.uid ? '' : userData.uid,
				email: !userData.email ? '' : userData.email,
				birthdate: !userData.birthdate ? '' : userData.birthdate.split('T')[0],
				name: !userData.name ? '' : userData.name,
				phone_number: !userData.phone_number ? '' : userData.phone_number,
				weight: !userData.weight ? '' : userData.weight,
				height: !userData.height ? '' : userData.height,
			});
		};
		fetchData();
	}, []);

	const getRandomInitials = (username: any) => {
		const names = username?.split(' ');
		const firstTwoNames = names?.slice(0, 2);
		const initials = firstTwoNames?.map((name: any) => name[0]).join('');
		return initials?.toUpperCase();
	};

	const initials = getRandomInitials(!dataLogin?.name ? 'Hallo Mama' : dataLogin?.name);
	const getFirstTwoSyllables = (str: any) => {
		const words = str?.split(' ');
		return words?.slice(0, 1).join(' ');
	};
	useEffect(() => {
		setCount(0);
		setNilai(false);
		if (Cookies.load('d_login') && router.asPath === '/login') {
			router.push('/');
			messageC('Mama sudah login ke akun Mama. Yuk lanjut jelajahi Hallobumil~');
		} else if (Cookies.load('d_login') && router.asPath === '/register') {
			router.push('/');
			messageC('Mama sudah login nih. Kalau mau buat akun baru, Mama perlu logout dulu ya.');
		} else if (router.asPath === '/beranda') {
			router.push('/');
		}
	}, [router.asPath]);

	const [inputValue, setInputValue] = useState('');
	const handleInputChange = (e: any) => {
		setInputValue(e.target.value);
	};

	const handlePressEnter = async () => {
		const queryParams = new URLSearchParams({ name: inputValue }).toString();
		router.push(`/search?${queryParams}`);
	};

	const handlePressLogin = async () => {
		router.push('/login');
	};
	const handlePressRegister = async () => {
		router.push('/register');
	};

	// const [logout, setLogout] = useState(false);
	const handleLogout = async () => {
		// setLogout(true);
		// Cookies.remove('d_login', { path: '/' });
		setIsModalOpen(true);
		handleClick();
	};

	const handleOk = () => {
		setIsModalOpen(false);
		Cookies.remove('d_login', { path: '/' });
		Cookies.remove('login_success');
		Cookies.remove('register_success');
		router.push('/');
		router.reload();
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const handleOkSession = () => {
		setIsModalOpenSession(false);
		Cookies.remove('d_login', { path: '/' });
		Cookies.remove('login_success');
		Cookies.remove('register_success');
		router.push('/login');
	};
	const handleCancelSession = () => {
		setIsModalOpenSession(false);
		Cookies.remove('d_login');
		Cookies.remove('login_success');
		Cookies.remove('register_success');
		// router.push('/login');
	};

	const Logout = (
		<Menu style={{ width: '135px', paddingLeft: '10px', marginTop: '15px', borderRadius: '10px' }}>
			<Menu.Item key="0">
				<a onClick={() => handleLogout()} id="header-beranda">
					<Typography
						style={{
							textAlign: 'left',
							color: '#F48A8A',
						}}
					>
						Keluar
					</Typography>
				</a>
			</Menu.Item>
		</Menu>
	);

	const menu = (
		<Menu style={{ marginTop: '20px', width: '375px', paddingLeft: '10px' }}>
			<Menu.Item key="1">
				<a
					href={'/'}
					style={{ color: `${router.asPath === '/' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-beranda"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${router.asPath === '/' ? '#F48A8A' : '#343A40'}`,
						}}
					>
						Beranda
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="2">
				<a
					href={'/artikel'}
					style={{ color: `${router.asPath === '/artikel' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-artikel"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${
								router.asPath === '/artikel'
									? '#F48A8A'
									: router.asPath === '/kehamilan'
									? '#F48A8A'
									: router.asPath === '/pra-kehamilan'
									? '#F48A8A'
									: router.asPath === '/pasca-kehamilan'
									? '#F48A8A'
									: router.asPath === '/resep'
									? '#F48A8A'
									: router.pathname === '/kehamilan/[sub]'
									? '#F48A8A'
									: router.pathname === '/pra-kehamilan/[sub]'
									? '#F48A8A'
									: router.pathname === '/pasca-kehamilan/[sub]'
									? '#F48A8A'
									: router.pathname === '/resep/[sub]'
									? '#F48A8A'
									: router.pathname === '/search'
									? '#F48A8A'
									: '#343A40'
							}`,
						}}
					>
						Artikel
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="3">
				<a
					href={'/komunitas'}
					style={{ color: `${router.asPath === '/komunitas' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-komunitas"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${router.asPath === '/komunitas' ? '#F48A8A' : '#343A40'}`,
						}}
					>
						Komunitas
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="4">
				<a
					href={'/event'}
					style={{ color: `${router.asPath === '/event' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-event"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${router.asPath === '/event' ? '#F48A8A' : '#343A40'}`,
						}}
					>
						Info Acara
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="5">
				<a
					href={'/kalender-kesuburan'}
					style={{ color: `${router.asPath === '/kalender-kesuburan' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-kalender-kesuburan"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${router.asPath === '/kalender-kesuburan' ? '#F48A8A' : '#343A40'}`,
						}}
					>
						Hitung Masa Subur
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="6">
				<a
					href={'/kalender-hpl'}
					style={{ color: `${router.asPath === '/kalender-hpl' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-kalender-hpl"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${router.asPath === '/kalender-hpl' ? '#F48A8A' : '#343A40'}`,
						}}
					>
						Hitung HPL
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="7">
				<a
					href={'/hubungi-kami'}
					style={{ color: `${router.asPath === '/hubungi-kami' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-hubungi-kami"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${router.asPath === '/hubungi-kami' ? '#F48A8A' : '#343A40'}`,
						}}
					>
						Hubungi Kami
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="8">
				<Button
					type="primary"
					onClick={handlePressLogin}
					id="header-login"
					style={{
						borderRadius: '15px',
						width: '100%',
					}}
				>
					Masuk
				</Button>
			</Menu.Item>
			<Menu.Item key="9">
				<Button
					type="default"
					onClick={handlePressRegister}
					style={{
						borderRadius: '15px',
						border: '1px solid #F48A8A',
						color: '#F48A8A',
						width: '100%',
					}}
					id="header-daftar"
				>
					Daftar
				</Button>
			</Menu.Item>
		</Menu>
	);
	const menuLogin = (
		<Menu style={{ marginTop: '20px', width: '375px', paddingLeft: '10px' }}>
			<Menu.Item key="0">
				<Row>
					<Col style={{ marginRight: '10px' }}>
						{dataLogin?.profile_image_files ? (
							<span>
								<Avatar
									src={dataLogin?.profile_image_files[0]?.path}
									style={{ cursor: 'pointer' }}
								/>
							</span>
						) : (
							<Button className={styles.avatar} style={{ cursor: 'pointer' }} shape="circle">
								{initials}
							</Button>
						)}
					</Col>
					<Col>
						<Typography
							style={{
								textAlign: 'left',
								color: '#000',
								marginTop: '5px',
							}}
						>
							Hi, {getFirstTwoSyllables(dataLogin?.name)}
						</Typography>
					</Col>
				</Row>
			</Menu.Item>
			<Menu.Item key="1">
				<a
					href={'/'}
					style={{ color: `${router.asPath === '/' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-beranda"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${router.asPath === '/' ? '#F48A8A' : '#343A40'}`,
						}}
					>
						Beranda
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="2">
				<a
					href={'/artikel'}
					style={{ color: `${router.asPath === '/artikel' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-artikel"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${
								router.asPath === '/artikel'
									? '#F48A8A'
									: router.asPath === '/kehamilan'
									? '#F48A8A'
									: router.asPath === '/pra-kehamilan'
									? '#F48A8A'
									: router.asPath === '/pasca-kehamilan'
									? '#F48A8A'
									: router.pathname === '/kehamilan/[sub]'
									? '#F48A8A'
									: router.pathname === '/pra-kehamilan/[sub]'
									? '#F48A8A'
									: router.pathname === '/pasca-kehamilan/[sub]'
									? '#F48A8A'
									: router.asPath === '/resep/'
									? '#F48A8A'
									: router.pathname === '/resep/[sub]'
									? '#F48A8A'
									: router.pathname === '/search'
									? '#F48A8A'
									: '#343A40'
							}`,
						}}
					>
						Artikel
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="3">
				<a
					href={'/komunitas'}
					style={{ color: `${router.asPath === '/komunitas' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-komunitas"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${router.asPath === '/komunitas' ? '#F48A8A' : '#343A40'}`,
						}}
					>
						Komunitas
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="4">
				<a
					href={'/event'}
					style={{ color: `${router.asPath === '/event' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-event"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${router.asPath === '/event' ? '#F48A8A' : '#343A40'}`,
						}}
					>
						Info Acara
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="5">
				<a
					href={'/kalender-kesuburan'}
					style={{ color: `${router.asPath === '/kalender-kesuburan' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-kalender-kesuburan"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${router.asPath === '/kalender-kesuburan' ? '#F48A8A' : '#343A40'}`,
						}}
					>
						Hitung Masa Subur
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="6">
				<a
					href={'/kalender-hpl'}
					style={{ color: `${router.asPath === '/kalender-hpl' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-kalender-hpl"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${router.asPath === '/kalender-hpl' ? '#F48A8A' : '#343A40'}`,
						}}
					>
						Hitung HPL
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="7">
				<a
					href={'/hubungi-kami'}
					style={{ color: `${router.asPath === '/hubungi-kami' ? '#F48A8A' : '#343A40'}` }}
					onClick={() => handleClick()}
					id="header-hubungi-kami"
				>
					<Typography
						style={{
							textAlign: 'left',
							cursor: 'pointer',
							color: `${router.asPath === '/hubungi-kami' ? '#F48A8A' : '#343A40'}`,
						}}
					>
						Hubungi Kami
					</Typography>
				</a>
			</Menu.Item>
			<Menu.Item key="8">
				<Button
					type="primary"
					onClick={() => handleLogout()}
					id="header-logout"
					style={{
						borderRadius: '15px',
						width: '100%',
					}}
				>
					Keluar
				</Button>
			</Menu.Item>
		</Menu>
	);
	const dataMenu = [
		{
			key: 1,
			name: 'Beranda',
			path: '/',
		},
		{
			key: 2,
			name: 'Artikel',
			path: '/artikel',
			path1: [
				'/resep',
				'/resep/[sub]',
				'/kehamilan',
				'/kehamilan/[sub]',
				'/pra-kehamilan',
				'/pra-kehamilan/[sub]',
				'/pasca-kehamilan',
				'/pasca-kehamilan/[sub]',
				'/search',
			],
		},
		{
			key: 3,
			name: 'Komunitas',
			path: '/komunitas',
		},
		{
			key: 4,
			name: 'Info Acara',
			path: '/event',
		},
		{
			key: 5,
			name: 'Hitung Masa Subur',
			path: '/kalender-kesuburan',
		},
		{
			key: 6,
			name: 'Hitung HPL',
			path: '/kalender-hpl',
		},
		{
			key: 7,
			name: 'Hubungi Kami',
			path: '/hubungi-kami',
		},
	];

	return (
		<div className={styles['page-body-wrap']}>
			<div className="container">
				<Affix style={{ background: 'transparent', zIndex: 99 }} className={styles.positionTop}>
					<Row>
						<Col md={5} xs={12} lg={5} sm={5} className={styles.positionTop}>
							<a href={'/'}>
								<a className={styles.logo} id="header-logo-hb">
									<Image
										width={160}
										height={40}
										src="/images/header/logoHallobumil.webp"
										alt="Logo HalloBumil"
										preview={false}
									/>
								</a>
							</a>
						</Col>
						<Col md={19} xs={12} xl={19} lg={19} sm={19}>
							{xs ? (
								<div>
									<div style={{ float: 'right', paddingTop: '30px', paddingRight: '15px' }}>
										<Dropdown overlay={dataLogin?.uid?.length ? menuLogin : menu} visible={nilai}>
											{/* <UnorderedListOutlined style={{ color: '#F48A8A' }} /> */}
											{nilai === false ? (
												<IconCustom iconName="hamburger-menu" onClick={() => handleClick()} />
											) : (
												<IconCustom iconName="close-menu" onClick={() => handleClick()} />
											)}
										</Dropdown>
									</div>
								</div>
							) : (
								<div style={{ marginTop: '30px' }}>
									<Row>
										<Col
											md={dataLogin?.uid?.length > 0 ? 14 : 12}
											xs={0}
											xl={dataLogin?.uid?.length > 0 ? 14 : 13}
											lg={dataLogin?.uid?.length > 0 ? 14 : 12}
											sm={dataLogin?.uid?.length > 0 ? 14 : 10}
										>
											<div style={{ textAlign: 'right', marginTop: '-5px', marginRight: '15px' }}>
												<Input.Group compact>
													<Input
														style={{
															width: 'calc(80% - 40px)',
															borderTopLeftRadius: '8px',
															borderBottomLeftRadius: '8px',
															textAlign: 'left',
														}}
														placeholder="Cari..."
														onChange={handleInputChange}
														onPressEnter={handlePressEnter}
													/>
													<Button
														type="primary"
														onClick={handlePressEnter}
														style={{
															borderTopRightRadius: '8px',
															borderBottomRightRadius: '8px',
														}}
													>
														<SearchOutlined />
													</Button>
												</Input.Group>
											</div>
										</Col>
										<Col style={{ float: 'right' }}>
											{dataLogin?.uid?.length > 0 ? (
												<Typography
													style={{
														cursor: 'pointer',
														color: '#343A40',
														display: 'inline',
														marginRight: '10px',
														marginLeft: '200px',
														fontWeight: '400',
													}}
												>
													Hi, {!dataLogin?.name ? 'Mama' : getFirstTwoSyllables(dataLogin?.name)}
												</Typography>
											) : (
												''
											)}

											{dataLogin?.uid?.length > 0 ? (
												<Dropdown overlay={Logout} placement="bottomRight" trigger={['hover']}>
													{dataLogin?.profile_image_files ? (
														<Avatar
															src={dataLogin?.profile_image_files[0]?.path}
															style={{ cursor: 'pointer' }}
														/>
													) : (
														<Button
															className={styles.avatar}
															style={{ cursor: 'pointer' }}
															shape="circle"
														>
															{initials}
														</Button>
													)}
												</Dropdown>
											) : (
												<div style={{ display: 'flex', marginTop: '-5px', marginLeft: '80px' }}>
													<Input.Group compact>
														<Button
															type="default"
															onClick={handlePressRegister}
															style={{
																borderRadius: '15px',
																border: '1px solid #F48A8A',
																color: '#F48A8A',
															}}
														>
															Daftar
														</Button>
													</Input.Group>
													<span
														style={{
															width: '1px',
															color: '#D9D9D9',
															height: '30px',
															marginLeft: '15px',
															marginRight: '17px',
															marginTop: '5px',
														}}
													>
														|
													</span>
													<Input.Group compact>
														<Button
															type="primary"
															onClick={handlePressLogin}
															style={{
																borderRadius: '15px',
															}}
														>
															Masuk
														</Button>
													</Input.Group>
												</div>
											)}
										</Col>
									</Row>
								</div>
							)}
						</Col>
					</Row>
					<Row style={{ zIndex: 99 }}>
						<Col md={24} xs={0} xl={24} lg={24} sm={24}>
							{dataMenu.map((item: any) => {
								const isActive =
									router.pathname === item.path ||
									(item.path1 && item.path1.includes(router.pathname));
								return (
									<a href={item.path} id="header-beranda" key={item.key}>
										<Typography
											style={{
												cursor: 'pointer',
												color: `${isActive ? '#F48A8A' : '#4A4545'}`,
												display: 'inline',
												marginRight: '30px',
												fontWeight: '600',
												textAlign: 'left',
											}}
											className={styles.newMenu}
										>
											{item.name}
										</Typography>
									</a>
								);
							})}
						</Col>
					</Row>
					<Row>
						<Col md={0} sm={24} xs={24} style={{ textAlign: 'center', marginTop: '-15px' }}>
							<Input.Group compact>
								<Input
									style={{
										width: '230px',
										borderTopLeftRadius: '8px',
										borderBottomLeftRadius: '8px',
										textAlign: 'left',
									}}
									placeholder="Cari..."
									onChange={handleInputChange}
									onPressEnter={handlePressEnter}
								/>
								<Button
									type="primary"
									onClick={handlePressEnter}
									style={{
										borderTopRightRadius: '8px',
										borderBottomRightRadius: '8px',
									}}
								>
									<SearchOutlined />
								</Button>
							</Input.Group>
						</Col>
					</Row>
				</Affix>

				<Modal
					visible={isModalOpen}
					onOk={handleOk}
					onCancel={handleCancel}
					footer={null}
					width={360}
				>
					<div style={{ textAlign: 'center' }}>
						<Image
							src="/images/default/logouthb.svg"
							preview={false}
							style={{ marginTop: '40px', marginBottom: '20px' }}
							alt="logout"
						/>
						<Typography className={styles.titleModal}> Yakin Ma Mau Keluar ?</Typography>
						<Typography className={styles.pModal}>
							Mama nggak bisa lagi akses beberapa fitur seru di Hallobumil
						</Typography>
						<div>
							<ButtonBorderKomunitas
								style={{
									backgroundColor: '#F48A8A',
									color: 'white',
									cursor: 'pointer',
									width: '90%',
									marginTop: '10px',
									marginBottom: '10px',
								}}
								text={'Kembali'}
								onClick={handleCancel}
							/>
						</div>
						<div>
							<ButtonBorder
								style={{
									cursor: 'pointer',
									width: '90%',
									marginBottom: '30px',
								}}
								text={'Lanjut Keluar'}
								onClick={handleOk}
							/>
						</div>
					</div>
				</Modal>

				{/* session token habis */}
				<Modal
					visible={isModalOpenSession}
					onOk={handleOkSession}
					onCancel={handleCancelSession}
					footer={null}
					width={360}
				>
					<div style={{ textAlign: 'center' }}>
						<Image
							src="/images/default/logouthb.svg"
							preview={false}
							style={{ marginTop: '40px', marginBottom: '20px' }}
							alt="logout"
						/>
						<Typography className={styles.titleModal}> Sesi Mama Sudah Berakhir</Typography>
						<Typography className={styles.pModal}>
							Supaya akun Mama aman, silahkan login lagi ya!
						</Typography>
						<div>
							<ButtonBorderKomunitas
								style={{
									backgroundColor: '#F48A8A',
									color: 'white',
									cursor: 'pointer',
									width: '90%',
									marginTop: '10px',
									marginBottom: '10px',
								}}
								text={'Kembali'}
								onClick={handleCancelSession}
							/>
						</div>
						<div>
							<ButtonBorder
								style={{
									cursor: 'pointer',
									width: '90%',
									marginBottom: '30px',
								}}
								text={'Login'}
								onClick={handleOkSession}
							/>
						</div>
					</div>
				</Modal>
			</div>
		</div>
	);
};
export default HeaderNavigator;
